import { useEffect, useState } from "react";
import NoSaldoComponent from "component/NoSaldoComponent/NoSaldoComponent";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import { useNavigate } from "react-router-dom";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { createVale, getEmpresasByCuentaContrato } from "component/api";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import Vale from "component/Vale/Vale";
import ValeClass from "component/ValeClass/ValeClass";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import TagManager from "react-gtm-module";
import "./ValeComponent.css";

const tagManagerArgs = {
  dataLayer: {
    userId: "001",
    userProject: "project",
    page: "valeComponent",
  },
  dataLayerName: "Vales",
};

const ValeComponent = (props) => {
  TagManager.dataLayer(tagManagerArgs);

  const vale = localStorage.getItem("valeType");
  const cuentaContrato = localStorage.getItem("cuentaContrato");
  var empresa = [];
  const [empresaId, setEmpresaId] = useState("");
  const [empresaEmail, setEmpresaEmail] = useState("");
  const [empresaDomicilio, setEmpresaDomicilio] = useState("");

  async function getEmpresasByCuentaContratoFunc(cc) {
    const res = await getEmpresasByCuentaContrato(cc);
    empresa = res.data;
    //setEmpresaNombre(empresa.razonSocial);
    setEmpresaId(empresa.id);
    setEmpresaEmail(empresa.correoElectronico);
    setEmpresaDomicilio(empresa.localidad + " " + empresa.direccion);
  }
  useEffect(() => {
    try {
      console.log(cuentaContrato);
      getEmpresasByCuentaContratoFunc(cuentaContrato);
    } catch (err) {} // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cuentaContrato]);

  const [valeGenerado, setValeGenerado] = useState(false);
  const [spinner, setSpinner] = useState(" ");
  const [qr, setQr] = useState(false);
  const [noSaldo, setNoSaldo] = useState(false);

  async function createValeFunc(object) {
    try {
      const res = await createVale(object);

      localStorage.setItem("idvale", res.data.id);

      if (res.status === 201) {
        setValeGenerado(true);
        setSpinner(" ");
      }
    } catch (e) {
      setSpinner(" ");
      setNoSaldo(true);
      setValeGenerado(false);
    }
  }
  function generarVale() {
    setSpinner(null);
    const obj = {
      empresa: JSON.parse(`{ "id": ${empresaId} }`),
      tipoVale: JSON.parse(`{ "id": ${vale}  }`),
    };
    createValeFunc(obj);

    localStorage.setItem("empresaEmail", empresaEmail);
    localStorage.setItem("empresaDomicilio", empresaDomicilio);
    setQr(true);
    //window.history.replaceState(null, null, "/");
    if (valeGenerado === true) {
      //setValeCompo(false);
      // setValeClase(true);
    }
    return true;
  }

  const logeado = sessionStorage.getItem("logeado");

  let history = useNavigate();
  const buttons = (
    <Container maxWidth="md">
      <Grid container spacing={10} sx={{ width: "100%" }}>
        <Grid size="grow">
          <div
            style={{
              width: "100%",
              paddingLeft: "8%",
              paddingRight: "8%",
              backgroundColor: "white",
              border: "solid",
              borderColor: "#0055A6",
              borderWidth: "1px",
              borderRadius: "4px",
            }}
          >
            <Button
              onClick={() => {
                localStorage.removeItem("idvale");
                history(-1);
              }}
              startIcon={<ArrowBackIosIcon />}
              style={{
                textTransform: "none",
                color: "#0055A6",
              }}
            >
              Volver
            </Button>
          </div>
        </Grid>
        <Grid size="grow">
          <div
            style={{
              width: "100%",
              paddingLeft: "8%",
              paddingRight: "8%",
              border: "solid",
              borderColor: "#009BDB",
              borderWidth: "1px",
              borderRadius: "4px",
              backgroundColor: "#009BDB",
            }}
          >
            <Button
              onClick={() => generarVale()}
              endIcon={<ArrowForwardIosIcon />}
              style={{
                textTransform: "none",
                color: "white",
              }}
            >
              Confirmar
            </Button>
          </div>
        </Grid>
      </Grid>
    </Container>
  );
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        flexDirection: "column",
      }}
    >
      {logeado === null && (
        <div style={{ marginLeft: "10%", marginTop: "4%" }}>
          <h2>Por favor iniciar la sesión .</h2>
        </div>
      )}
      {logeado === "true" && (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
          }}
        >
          {valeGenerado === false && noSaldo === true && <NoSaldoComponent />}
          {valeGenerado === false && noSaldo === false && (
            <div>
              <Vale qr={qr} />
            </div>
          )}
          {valeGenerado === false && noSaldo === false && (
            <div style={{ alignSelf: "center", width: "25%" }}>{buttons}</div>
          )}
          {spinner ? (
            spinner
          ) : (
            <Backdrop className="vale-component-backdrop" open>
              <CircularProgress color="inherit" />
            </Backdrop>
          )}
          {valeGenerado === true && <ValeClass />}
          <br />
        </div>
      )}
    </div>
  );
};
export default ValeComponent;
